import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=067af7d2&scoped=true"
import script from "./UserTabs.vue?vue&type=script&lang=js"
export * from "./UserTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067af7d2",
  null
  
)

export default component.exports